import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import 'hammerjs';

import { GeoJsonService } from './services/geo-json.service';

import { MapComponent } from './map/map.component';
import { DialogComponent } from './dialog/dialog.component';
import { HistDevComponent } from './hist-dev/hist-dev.component';
import { AppRoutingModule } from './app-routing.module';
import { ChartsModule } from './charts/charts.module';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    DialogComponent,
    HistDevComponent,
  ],
  imports: [
      AppRoutingModule,
      BrowserModule,
      BrowserAnimationsModule,
      ChartsModule,
      FormsModule,
      HttpModule,
      MatTabsModule,
      MatSelectModule,
      MatRadioModule,
      MatDialogModule,
      MatGridListModule,
      MatButtonModule,
      MatIconModule,
      NgbModule.forRoot()
  ],
  entryComponents: [DialogComponent],
  providers: [GeoJsonService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts